import React from 'react'
import { VscHome } from 'react-icons/vsc'
import '../Notebook.css'
import { TbClockHour3, TbMessage, TbStar } from 'react-icons/tb'
import { BsThreeDots } from 'react-icons/bs'
import Dropdown from '../../../components/Dropdown/Dropdown'
import { useLanguage } from '../../../LanguageProvider'
import NoteSearchInput from '../components/NoteSearchInput/NoteSearchInput'
import AddNoteButton from '../components/AddNoteButton/AddNoteButton'
import IdeaCard from '../components/IdeaCard/IdeaCard'

export default function Ideas() {
    const { getTranslation } = useLanguage();
    let dropdownOptions = [
        {
            value: "tag1",
            label: "tag1",
        }
    ]
    return (
        <div className="ideas-container">
            <div className="notebook-header">
                <div className="notebook-header-left">
                    <span className="notebook-header-left-home-button"><VscHome /></span>
                    <span>Personal/Daily Notes</span>
                </div>
                <div className="notebook-header-right">
                    <span className="notebook-header-share-button">Share</span>
                    <TbMessage className="notebook-header-right-button" size={16} />
                    <TbClockHour3 className="notebook-header-right-button" size={16} />
                    <TbStar className="notebook-header-right-button" size={16} />
                    <BsThreeDots className="notebook-header-right-button" size={16} />
                </div>
            </div>

            <div className='ideas-search-filter-holder'>
                <div className="allnotes-sidebar-header">
                    <NoteSearchInput />
                    <AddNoteButton />
                </div>

                <Dropdown
                    options={dropdownOptions}
                    placeholder={getTranslation("selectFromList")}
                    value={""}
                    style={{ marginRight: '0px' }}
                />
            </div>


            <div className="ideas-grid">
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
                <IdeaCard />
            </div>
        </div>
    )
}
